import { Component } from "react";
import { Link } from "react-router-dom";
import api from "../../utils/axios";
import { connect } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";

import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, showContaimerLoader, removeChar, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
const module = "userrole";
const modulePath = "/role";
const moduleName = "User Role";
const moduleID = 28;
class Form extends Component {
  constructor(props) {
    super(props);
    console.log(this.props, "this.props");
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        roleName: "",
        roleModules: [],
        roleStatus: "",
      },
      detaildata: [],
      moduleList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
    this.loadModule();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;

          const roleStatus = result.roleStatus === "A" ? "Active" : "In Active";
          const status =
            result.roleStatus !== "" && result.roleStatus !== null
              ? {
                  label: roleStatus,
                  value: result.roleStatus,
                }
              : "";
          const clientupdatedata = {
            roleName: result.roleName,
            roleModules: result.roleModules !== "" && result.roleModules !== null ? JSON.parse(result.roleModules) : [],
            roleStatus: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadModule = async () => {
    try {
      const res = await api.get("/userrole/getModuleList");
      console.log(res, "resresres");
      const result = res?.data?.result ?? [];
      this.setState({ moduleList: result });
    } catch (e) {}
  };
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;

    const postObject = {
      roleName: postData.roleName,
      roleModules: postData.roleModules.length > 0 ? JSON.stringify(postData.roleModules) : "",
      roleStatus: postData.roleStatus?.value ?? "I",
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            moduleList={this.state.moduleList}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { roleName, roleStatus } = props.fields;

  return {
    fields: ["roleName", "roleStatus"],
    validations: {
      roleName: [[isEmpty, roleName]],
      roleStatus: [[isSingleSelect, roleStatus]],
    },
  };
}

class PostForm extends Component {
  goBack() {
    this.props.history.push(modulePath);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  selectModule(moduleID, accessType, e) {
    const isChecked = e.target.checked;
    let modules = this.props.fields.roleModules;
    const index = modules.findIndex((m) => m.moduleID === moduleID);
    // ✅ If ALL option
    if (accessType === "all") {
      if (isChecked) {
        if (index === -1) {
          modules.push({ moduleID, access: ["view", "add", "edit", "delete"] });
        } else {
          modules[index].access = ["view", "add", "edit", "delete"];
        }
      } else {
        if (index !== -1) {
          modules.splice(index, 1);
        }
      }
    } else {
      if (isChecked) {
        if (index === -1) {
          // Add new module with access
          modules.push({ moduleID, access: [accessType] });
        } else {
          // Add access if not exists
          if (!modules[index].access.includes(accessType)) {
            modules[index].access.push(accessType);
          }
        }
      } else {
        if (index !== -1) {
          // Remove the accessType
          modules[index].access = modules[index].access.filter((a) => a !== accessType);

          // If no access left → remove module entirely
          if (modules[index].access.length === 0) {
            modules.splice(index, 1);
          }
        }
      }
    }
    this.props.onChange("roleModules", modules);
    console.log(modules, "modulesmodulesmodules");
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgroleName,
      errMsgStatus = "";
    if ($validation.roleName.error.reason !== undefined) {
      errMsgroleName = $validation.roleName.show && <span className="error">{$validation.roleName.error.reason}</span>;
    }
    if ($validation.roleStatus.error.reason !== undefined) {
      errMsgStatus = $validation.roleStatus.show && <span className="error">{$validation.roleStatus.error.reason}</span>;
    }
    const excludeLsit = ["Dashboard", "Reports", "Portage Bill"];
    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Role Name<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control" placeholder="Role Name" name="roleName" value={fields.roleName} {...$field("roleName", (e) => onChange("roleName", e.target.value))} />
              {errMsgroleName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.roleStatus}
                onChange={this.handleSelectChange.bind(this, "roleStatus")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>

            <div class="table-responsive mt-4">
              <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead className="table-primary">
                  <tr>
                    <th>Modules</th>
                    <th class="text-center">View</th>
                    <th class="text-center">Add</th>
                    <th class="text-center">Edit</th>
                    <th class="text-center">Delete</th>
                    <th class="text-center">All</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.moduleList.length > 0 &&
                    this.props.moduleList.map((item, index) => {
                      const findIndex = fields.roleModules.findIndex((m) => m.moduleID === item.moduleID);
                      let viewChecked = false;
                      let addhecked = false;
                      let editChecked = false;
                      let deleteChecked = false;
                      if (findIndex >= 0) {
                        viewChecked = fields.roleModules[findIndex].access.includes("view") ? true : false;
                        addhecked = fields.roleModules[findIndex].access.includes("add") ? true : false;
                        editChecked = fields.roleModules[findIndex].access.includes("edit") ? true : false;
                        deleteChecked = fields.roleModules[findIndex].access.includes("delete") ? true : false;
                      }
                      console.log(findIndex, "findIndexfindIndex");
                      return (
                        <tr id="mobule_5" key={index}>
                          <td>{item.moduleName} </td>
                          <td class="">
                            <div class="custom-controls-stacked  d-flex justify-content-center align-items-center">
                              <label class="custom-control custom-checkbox-md">
                                <input type="checkbox" class="custom-control-input module_check" onChange={this.selectModule.bind(this, item.moduleID, "view")} checked={viewChecked} />
                                <span class="custom-control-label"></span>
                              </label>
                            </div>
                          </td>
                          <td>
                            {excludeLsit.indexOf(item.moduleName) < 0 && (
                              <div class="custom-controls-stacked  d-flex justify-content-center align-items-center">
                                <label class="custom-control custom-checkbox-md">
                                  <input type="checkbox" class="custom-control-input module_check" onChange={this.selectModule.bind(this, item.moduleID, "add")} checked={addhecked} />
                                  <span class="custom-control-label"></span>
                                </label>
                              </div>
                            )}
                          </td>
                          <td>
                            {excludeLsit.indexOf(item.moduleName) < 0 && (
                              <div class="custom-controls-stacked  d-flex justify-content-center align-items-center">
                                <label class="custom-control custom-checkbox-md">
                                  <input type="checkbox" class="custom-control-input module_check" onChange={this.selectModule.bind(this, item.moduleID, "edit")} checked={editChecked} />
                                  <span class="custom-control-label"></span>
                                </label>
                              </div>
                            )}
                          </td>
                          <td class="text-center">
                            {excludeLsit.indexOf(item.moduleName) < 0 && (
                              <div class="custom-controls-stacked  d-flex justify-content-center align-items-center">
                                <label class="custom-control custom-checkbox-md">
                                  <input type="checkbox" class="custom-control-input module_check" onChange={this.selectModule.bind(this, item.moduleID, "delete")} checked={deleteChecked} />
                                  <span class="custom-control-label"></span>
                                </label>
                              </div>
                            )}
                          </td>

                          <td class="text-center">
                            {excludeLsit.indexOf(item.moduleName) < 0 && (
                              <div class="custom-controls-stacked  d-flex justify-content-center align-items-center">
                                <label class="custom-control custom-checkbox-md">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input module_check"
                                    onChange={this.selectModule.bind(this, item.moduleID, "all")}
                                    checked={viewChecked && editChecked && editChecked && deleteChecked ? true : false}
                                  />
                                  <span class="custom-control-label"></span>
                                </label>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
